import { Button } from "antd";
import { FC, ReactNode } from "react";
import { Save } from "lucide-react";

interface ContentPanelProps {
  title: string;
  selectedServiceLabel?: string;
  onSave: () => void;
  isSaving: boolean;
  children: ReactNode;
}

export const ContentPanel: FC<ContentPanelProps> = ({
  title,
  selectedServiceLabel,
  onSave,
  isSaving,
  children,
}) => {
  return (
    <div className="bg-white rounded-lg border h-full shadow-sm">
      <div className="p-4 border-b">
        <div className="flex justify-between items-center">
          <div className="font-medium">{title}</div>
          {selectedServiceLabel && (
            <div className="text-sm text-gray-600">
              Selected: {selectedServiceLabel}
            </div>
          )}
        </div>
      </div>

      {children}

      <div className="p-4 border-t flex justify-end">
        <Button
          className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          onClick={onSave}
          loading={isSaving}
          disabled={!selectedServiceLabel}
        >
          <Save size={16} />
          <span>Save Changes</span>
        </Button>
      </div>
    </div>
  );
};
